<div class="d-flex">
    <div class="reports-menu">
        <ul class="root pl-0">
            <mat-accordion>
                @for (item of tree(); track item.id) {
                    <mat-expansion-panel [expanded]="item.name === selectedGroup()">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ item.name === '' ? ('General.General' | translate) : item.name }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <ul class="group pl-0">
                            @for (subItem of item.children; track subItem.id) {
                                <li>
                                    <a
                                        [routerLink]="'/reports/' + subItem.id"
                                        (click)="clearCurrentResponse()"
                                        class="text-secondary"
                                        routerLinkActive="text-primary">
                                        <span>{{ subItem.name }}</span>
                                        @if (subItem.hasSchedule) {
                                            <mat-icon [matTooltip]="'ReportSchedule.ScheduledTooltip' | translate">event_repeat</mat-icon>
                                        }
                                    </a>
                                </li>
                            }
                        </ul>
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </ul>
    </div>
    <div class="flex-fill reports-form">
        <router-outlet class="outlet-disable-full-height" />
    </div>
</div>
